// Exotics widgets share PricingProvider (architect E8). Thin pass-through.
import type { FC } from 'react';

import ExoticsMarketBandWidget from './exotics-market-band-widget';
import type { ExoticsMarketBandProps } from './types';

const ExoticsMarketBandWrapperProvider: FC<ExoticsMarketBandProps> = (props) => (
  <ExoticsMarketBandWidget {...props} />
);

export default ExoticsMarketBandWrapperProvider;
